export const environment = {
    production: false,
    "basePath": "https://api.test.safely.com/portal",
    "portalConfig": {
        "customerPortalBaseUrl": "https://api.test.safely.com/customerportal",
        "safelyAccountBaseUrl": "https://api.test.safely.com/account",
        "adminPortalBaseUrl": "https://api.test.safely.com/admin",
        legacyPortalAPIBasePath: 'https://legacy-api.test.safely.com/api/internal/v1',
        "production": false,
        createReservationEnabled: true,
         checkinPortalBasePath: 'https://checkin.test.safely.com'
    },
    msalConfig: {
        "auth": {
            "clientId": "a0382fb1-3c59-4337-9cef-df8c1717a516",
            "authority": "https://login.microsoftonline.com/b9c11c00-f76f-4e11-b244-68442b411785",
            "redirectUri": "https://admin.test.safely.com/",
            "postLogoutRedirectUri": "https://admin.test.safely.com/",
            "navigateToLoginRequestUrl": true,
            "validateAuthority": true
        },
        "cache": {
            "cacheLocation": "sessionStorage",
            "storeAuthStateInCookie": false
        },
        "guard": {
            "interactionType": "redirect",
            "authRequest": {
                "scopes": [
                    "openid",
                    "api://safely-portal-api-test/Portal.Write"
                ]
            },
            loginFailedRoute: "/login-failed"
        },
        "interceptor": {
            "interactionType": "redirect",
            protectedResourceMap: [
                {
                    uri: "https://graph.microsoft.com/v1.0/me",

                    scopes: ["user.read"]
                },
                {
                    uri: "https://api.test.safely.com/*",
                    scopes: ["api://safely-portal-api-test/Portal.Write"]
                },
                {
                    uri: "http://api.test.safelystay.com*",
                    scopes: ["api://safely-portal-api-test/Portal.Write"]
                },
                {
                    uri: "https://legacy-api.test.safely.com/*",
                    scopes: ["api://safely-portal-api-test/Portal.Write"]
                }
            ]
        },
        graphApiConfig: {
            scopes: ['user.read'],
            uri: 'https://graph.microsoft.com/v1.0/me',
        },
    },
    screeningReportAllowedUserIds: [
        '2b71436b-82fb-4c63-9b9e-04b962f45e87',
        '70de1003-451e-4fa9-9c89-d0e4ec1e1cfe',
        'd7045987-ac0f-4d27-98aa-065d03801d6e',
        'df88557c-d982-46a4-8086-623e86c3b266',
        '39d74756-e04f-4c40-8d79-ab954f346c86',
        'c97b2af0-5028-4d95-841d-fdfdcc120ed5',
        '0abe3c3e-2413-4f3b-bb5e-db45f92cc33c',
    ] as string[],
    "properties": {}
}